import { sleekRarityColor } from '../../../../modules/reveal';

/**
 * Rarity bar colours of the "Choose your pack style" sheet: the same
 * per-tier `SleekRarity` knobs as the reveal's chip and glow, under the
 * single `OddsSheet-barFill` knob — an operator who sets that one gets one
 * colour for every bar.
 */
export function tierBarFill(tierName: string): string {
  const rarity = sleekRarityColor(tierName) ?? sleekRarityColor('common');
  return `var(--co-OddsSheet-barFill, ${rarity})`;
}
